import { onKeyUp } from "Core/Events";

export const CityCode = (()=>{
    const Selector = {
        CITYCODE: '.js_postal_code',
    }

    onKeyUp(Selector.CITYCODE, addLineToCityCode);

    function addLineToCityCode(event) { //function to add dash after 2 signs of postal code
        var key = event.keyCode || event.charCode;
        if( key == 8 || key == 46 ){
            if(this.value.length == 4) {
                this.value(this.value.slice(0,-1));
            }
        }else{
            if(this.value.length >= 2 && !this.value.includes('-') && this.value.charAt(2) != '-') {
                this.value = this.value.substring(0,2) + '-' + this.value.substring(2);
            }
        }
    }
})();import { onKeyUp } from "Core/Events";

export const CityCode = (()=>{
    const Selector = {
        CITYCODE: '.js_postal_code',
    }

    onKeyUp(Selector.CITYCODE, addLineToCityCode);

    function addLineToCityCode(event) { //function to add dash after 2 signs of postal code
        var key = event.keyCode || event.charCode;
        if( key == 8 || key == 46 ){
            if(this.value.length == 4) {
                this.value(this.value.slice(0,-1));
            }
        }else{
            if(this.value.length >= 2 && !this.value.includes('-') && this.value.charAt(2) != '-') {
                this.value = this.value.substring(0,2) + '-' + this.value.substring(2);
            }
        }
    }
})();